import React from 'react'
import * as fn from '../../../../helper/uiFunctions';

const DocLink =(props)=>{
    const {formObject, viewData} = props;

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");

    //build the url for link
    const docModule = formObject.getValueFromKey(viewData, "dataList.module", formObject.docModule);
    const docView = formObject.getValueFromKey(viewData, "dataList.view", formObject.docView);
    const valLDT = formObject.getValueFromKey(viewData, "dataList.valLDT", 0);

    const url = fn.getShowDocumentLink(valLDT, viewData.val, "", 1, docModule, docView);

    return (
        <div className="saras-cell">
            <a target={docModule === formObject.docModule 
                    && fn.compareNumber(formObject.dtId, valLDT) ? '' : '_blank' } 
            className={`document-key uiLink ${valCssClass}`} href={url}>{viewData.valF}</a>
        </div>
    )
}

export default DocLink